import React from 'react';
import MaterialReportContent from './MaterialReportContent';
import { Card } from 'react-bootstrap';
import { t } from 'i18next';

const MaterialReport = () => {
  return (
    <Card className="shadow">
      <Card.Header>
        <h4> {t('Αναλυτική Αναφορά Αποβλήτου')} </h4>
      </Card.Header>

      <MaterialReportContent />
    </Card>
  );
};

export default MaterialReport;
